import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQueryWithAuth = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + "api/",
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        headers.set('Content-Type', 'application/json');
        return headers;
    },
    responseHandler: async (response) => {
        if (!response.ok) {
            const error = await response.text();
            throw new Error(error || response.statusText);
        }
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return response.json();
        } else {
            return response.text();
        }
    },
});

export const productUzbApi = createApi({
    reducerPath: 'productUzbApi',
    baseQuery: baseQueryWithAuth,
    endpoints: (builder) => ({
        createProductUzb: builder.mutation({
            query: (product) => ({
                url: 'ProductUzb/CreatProductUzb',
                method: 'POST',
                body: product,
            }),
            invalidatesTags: [{ type: 'Product', id: 'LIST' }],
        }),
        updateProductUzb: builder.mutation({
            query: ({ id, product }) => ({
                url: `ProductUzb/UpdateProductUzb?id=${id}`,
                method: 'PUT',
                body: product,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Product', id }],
        }),
        getProductUzbById: builder.query({
            query: (id) => `ProductUzb/GetProductUzb?id=${id}`,
            providesTags: (result, error, id) => [{ type: 'Product', id }],
        }),
        getAllProductsUzb: builder.query({
            query: ({ pageSize, pageIndex }) =>
                `ProductUzb/GetAllProductUzb?pageSize=${pageSize}&pageIndex=${pageIndex}`,
            providesTags: (result) =>
                result ?
                    [...result.map(({ id }) => ({ type: 'Product', id })), { type: 'Product', id: 'LIST' }]
                    : [{ type: 'Product', id: 'LIST' }],
        }),
        getAllProductsUzbByBrandName: builder.query({
            query: ({ pageSize, pageIndex, brandName }) =>
                `ProductUzb/GetAllProductByBrandNameUzb?pageSize=${pageSize}&pageIndex=${pageIndex}&brandName=${brandName}`,
            providesTags: (result) =>
                result ?
                    [...result.map(({ id }) => ({ type: 'Product', id })), { type: 'Product', id: 'LIST' }]
                    : [{ type: 'Product', id: 'LIST' }],
        }),
        deleteProductUzb: builder.mutation({
            query: (id) => ({
                url: `ProductUzb/DeleteProductAll?id=${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Product', id }, { type: 'Product', id: 'LIST' }],
        }),
    }),
});

export const {
    useCreateProductUzbMutation,
    useUpdateProductUzbMutation,
    useGetProductUzbByIdQuery,
    useGetAllProductsUzbQuery,
    useGetAllProductsUzbByBrandNameQuery,
    useDeleteProductUzbMutation,
} = productUzbApi;